import React from 'react';
import {Stack} from "@mui/material";
import IRList from "./IRList";
import IRHeader from "./components/IRHeader";

const ListOfIntelligenceRequirementsPage = () => {
    return (
        <Stack p={2} spacing={2} overflow={'auto'}>
            <IRHeader/>

            <IRList/>
        </Stack>
    );
};

export default ListOfIntelligenceRequirementsPage;